import React from 'react';
import { useTranslation } from "react-i18next";
import '../styles/terms.css';

const PoliticaApps = ({ lang }) => {

     const { t, i18n: { changeLanguage, language } } = useTranslation();

     if (language == "pt-BR") {
          return (
               <div>

                    <h2>POLÍTICA DE PRIVACIDADE DOS APLICATIVOS</h2>

                    <br />

                    <p><strong>Última atualização:</strong> 07/09/2024</p>

                    <br /><br />

                    <p>Esta Política de Privacidade descreve como os dados são coletados, utilizados, armazenados e protegidos ao utilizar aplicativos desenvolvidos por <strong>TLS Engenharia</strong>, tendo como desenvolvedor principal Thiago Leme da Silva.</p>

                    <br /><br />

                    <h3>1. DADOS COLETADOS</h3>

                    <p>Dependendo das funcionalidades do aplicativo, poderemos coletar:</p>

                    <br />

                    <ul>
                         <li>Informações fornecidas voluntariamente pelo usuário;</li>
                         <li>Dados técnicos do dispositivo (modelo, sistema operacional e versão);</li>
                         <li>Identificadores anônimos;</li>
                         <li>Dados de uso e interação com o aplicativo;</li>
                         <li>Relatórios de falhas (crash reports);</li>
                         <li>Informações necessárias para autenticação, processamento de pagamentos ou assinaturas, quando aplicável.</li>
                    </ul>

                    <br /><br />

                    <h3>2. FINALIDADE DO TRATAMENTO DOS DADOS</h3>

                    <p>Os dados coletados poderão ser utilizados para:</p>

                    <br />

                    <ul>
                         <li>Garantir o funcionamento adequado do aplicativo;</li>
                         <li>Melhorar desempenho, funcionalidades e experiência do usuário;</li>
                         <li>Corrigir erros e falhas técnicas;</li>
                         <li>Processar pagamentos e assinaturas;</li>
                         <li>Cumprir obrigações legais ou regulatórias.</li>
                    </ul>

                    <br /><br />

                    <h3>3. COMPARTILHAMENTO DE DADOS</h3>

                    <p>Os dados poderão ser compartilhados apenas quando necessário:</p>

                    <br />

                    <ul>
                         <li>Com provedores de serviços essenciais (como hospedagem, análise de dados, publicidade ou processamento de pagamentos);</li>
                         <li>Para cumprimento de obrigação legal ou ordem judicial;</li>
                         <li>Com plataformas de distribuição de aplicativos, quando aplicável.</li>
                    </ul>

                    <br /><br />

                    <h3>4. SERVIÇOS DE TERCEIROS</h3>

                    <p>Alguns aplicativos podem utilizar serviços de terceiros que possuem suas próprias políticas de privacidade, podendo coletar e processar dados conforme seus próprios termos.</p>

                    <br /><br />

                    <h3>5. ARMAZENAMENTO E SEGURANÇA</h3>

                    <p>Adotamos medidas técnicas e administrativas razoáveis para proteger os dados contra acesso não autorizado, perda, uso indevido ou divulgação indevida.</p>

                    <br />

                    <p>Contudo, nenhum método de transmissão ou armazenamento eletrônico é completamente seguro.</p>

                    <br /><br />

                    <h3>6. DIREITOS DO USUÁRIO</h3>

                    <p>Nos termos da legislação aplicável, incluindo a Lei Geral de Proteção de Dados (LGPD), o usuário poderá:</p>

                    <br />

                    <ul>
                         <li>Solicitar acesso aos seus dados;</li>
                         <li>Solicitar correção de dados incompletos ou incorretos;</li>
                         <li>Solicitar exclusão de dados, quando aplicável;</li>
                         <li>Revogar consentimento, quando esta for a base legal do tratamento.</li>
                    </ul>

                    <br /><br />

                    <h3>7. RETENÇÃO DOS DADOS</h3>

                    <p>Os dados serão mantidos apenas pelo tempo necessário para cumprir as finalidades descritas nesta Política ou conforme exigido por lei.</p>

                    <br /><br />

                    <h3>8. ALTERAÇÕES DESTA POLÍTICA</h3>

                    <p>Esta Política poderá ser atualizada periodicamente. O uso contínuo do aplicativo após alterações representa concordância com a versão vigente.</p>

                    <br /><br />

                    <h3>9. CONTATO</h3>

                    <p>
                         <strong>TLS Engenharia</strong><br />
                         E-mail: contato@tlsengenharia.com.br<br />
                         País: Brasil
                    </p>

               </div>
          );

     }
     else if (language == "es") {
          return (
               <div>

                    <h2>POLÍTICA DE PRIVACIDAD DE LAS APLICACIONES</h2>

                    <br />

                    <p><strong>Última actualización:</strong> 07/09/2024</p>

                    <br /><br />

                    <p>Esta Política de Privacidad describe cómo se recopilan, utilizan, almacenan y protegen los datos al utilizar aplicaciones desarrolladas por <strong>TLS Engenharia</strong>.</p>

                    <br /><br />

                    <h3>1. DATOS RECOPILADOS</h3>

                    <p>Dependiendo de las funcionalidades de la aplicación, podemos recopilar:</p>

                    <br />

                    <ul>
                         <li>Información proporcionada voluntariamente por el usuario;</li>
                         <li>Datos técnicos del dispositivo (modelo, sistema operativo y versión);</li>
                         <li>Identificadores anónimos;</li>
                         <li>Datos de uso e interacción con la aplicación;</li>
                         <li>Informes de fallos (crash reports);</li>
                         <li>Información necesaria para autenticación, procesamiento de pagos o suscripciones, cuando corresponda.</li>
                    </ul>

                    <br /><br />

                    <h3>2. FINALIDAD DEL TRATAMIENTO DE LOS DATOS</h3>

                    <p>Los datos recopilados podrán utilizarse para:</p>

                    <br />

                    <ul>
                         <li>Garantizar el correcto funcionamiento de la aplicación;</li>
                         <li>Mejorar el rendimiento, funcionalidades y experiencia del usuario;</li>
                         <li>Corregir errores y fallos técnicos;</li>
                         <li>Procesar pagos y suscripciones;</li>
                         <li>Cumplir obligaciones legales o regulatorias.</li>
                    </ul>

                    <br /><br />

                    <h3>3. COMPARTICIÓN DE DATOS</h3>

                    <p>Los datos solo podrán compartirse cuando sea necesario:</p>

                    <br />

                    <ul>
                         <li>Con proveedores de servicios esenciales (como alojamiento, análisis de datos, publicidad o procesamiento de pagos);</li>
                         <li>Para cumplir una obligación legal o una orden judicial;</li>
                         <li>Con plataformas de distribución de aplicaciones, cuando corresponda.</li>
                    </ul>

                    <br /><br />

                    <h3>4. SERVICIOS DE TERCEROS</h3>

                    <p>Algunas aplicaciones pueden utilizar servicios de terceros que poseen sus propias políticas de privacidad, pudiendo recopilar y procesar datos conforme a sus propios términos.</p>

                    <br /><br />

                    <h3>5. ALMACENAMIENTO Y SEGURIDAD</h3>

                    <p>Adoptamos medidas técnicas y administrativas razonables para proteger los datos contra accesos no autorizados, pérdida, uso indebido o divulgación indebida.</p>

                    <br />

                    <p>Sin embargo, ningún método de transmisión o almacenamiento electrónico es completamente seguro.</p>

                    <br /><br />

                    <h3>6. DERECHOS DEL USUARIO</h3>

                    <p>De acuerdo con la legislación aplicable, el usuario podrá:</p>

                    <br />

                    <ul>
                         <li>Solicitar acceso a sus datos;</li>
                         <li>Solicitar corrección de datos incompletos o incorrectos;</li>
                         <li>Solicitar la eliminación de datos, cuando corresponda;</li>
                         <li>Revocar el consentimiento, cuando esta sea la base legal del tratamiento.</li>
                    </ul>

                    <br /><br />

                    <h3>7. CONSERVACIÓN DE LOS DATOS</h3>

                    <p>Los datos se conservarán únicamente durante el tiempo necesario para cumplir las finalidades descritas en esta Política o según lo exija la ley.</p>

                    <br /><br />

                    <h3>8. CAMBIOS EN ESTA POLÍTICA</h3>

                    <p>Esta Política puede actualizarse periódicamente. El uso continuo implica la aceptación de la versión vigente.</p>

                    <br /><br />

                    <h3>9. CONTACTO</h3>

                    <p>
                         <strong>TLS Engenharia</strong><br />
                         Correo: contato@tlsengenharia.com.br<br />
                         País: Brasil
                    </p>

               </div>

          )
     }
     else {
          return (
               <div>

                    <h2>APPLICATION PRIVACY POLICY</h2>

                    <br />

                    <p><strong>Last update:</strong> 07/09/2024</p>

                    <br /><br />

                    <p>This Privacy Policy describes how data is collected, used, stored and protected when using applications developed by <strong>TLS Engenharia</strong>.</p>

                    <br /><br />

                    <h3>1. DATA COLLECTED</h3>

                    <p>Depending on the application's features, we may collect:</p>

                    <br />

                    <ul>
                         <li>Information voluntarily provided by the user;</li>
                         <li>Technical device data (model, operating system and version);</li>
                         <li>Anonymous identifiers;</li>
                         <li>Usage and interaction data;</li>
                         <li>Crash reports;</li>
                         <li>Information necessary for authentication, payment processing or subscriptions, when applicable.</li>
                    </ul>

                    <br /><br />

                    <h3>2. PURPOSE OF DATA PROCESSING</h3>

                    <p>Collected data may be used to:</p>

                    <br />

                    <ul>
                         <li>Ensure proper application functionality;</li>
                         <li>Improve performance, features and user experience;</li>
                         <li>Fix technical errors and failures;</li>
                         <li>Process payments and subscriptions;</li>
                         <li>Comply with legal or regulatory obligations.</li>
                    </ul>

                    <br /><br />

                    <h3>3. DATA SHARING</h3>

                    <p>Data may only be shared when necessary:</p>

                    <br />

                    <ul>
                         <li>With essential service providers (such as hosting, data analytics, advertising or payment processing);</li>
                         <li>To comply with legal obligations or court orders;</li>
                         <li>With application distribution platforms, when applicable.</li>
                    </ul>

                    <br /><br />

                    <h3>4. THIRD-PARTY SERVICES</h3>

                    <p>Some applications may use third-party services that have their own privacy policies and may collect and process data according to their own terms.</p>

                    <br /><br />

                    <h3>5. STORAGE AND SECURITY</h3>

                    <p>We adopt reasonable technical and administrative measures to protect data against unauthorized access, loss, misuse or improper disclosure.</p>

                    <br />

                    <p>However, no method of electronic transmission or storage is completely secure.</p>

                    <br /><br />

                    <h3>6. USER RIGHTS</h3>

                    <p>Under applicable laws, users may:</p>

                    <br />

                    <ul>
                         <li>Request access to their data;</li>
                         <li>Request correction of incomplete or inaccurate data;</li>
                         <li>Request deletion of data, when applicable;</li>
                         <li>Withdraw consent when it is the legal basis for processing.</li>
                    </ul>

                    <br /><br />

                    <h3>7. DATA RETENTION</h3>

                    <p>Data will be retained only for as long as necessary to fulfill the purposes described in this Policy or as required by law.</p>

                    <br /><br />

                    <h3>8. POLICY CHANGES</h3>

                    <p>This Policy may be updated periodically. Continued use implies acceptance of the current version.</p>

                    <br /><br />

                    <h3>9. CONTACT</h3>

                    <p>
                         <strong>TLS Engenharia</strong><br />
                         Email: contato@tlsengenharia.com.br<br />
                         Country: Brazil
                    </p>

               </div>
          )
     }




};

export default PoliticaApps;